export interface StylePresetOption {
  id: string;
  label: string;
  text: string;
  defaultAspectRatio?: string;
}

export const CUSTOM_STYLE_PRESET_ID = "custom";
export const CUSTOM_STYLE_PRESET_OPTION: StylePresetOption = { id: CUSTOM_STYLE_PRESET_ID, label: "Custom", text: "" };

export interface ReferenceImagePayload {
  mimeType: string;
  base64: string;
}

export interface WorldbuildingRoleOption {
  name: string;
  optionValue: string;
  defaultAspectRatio: string;
  defaultStylePresetId: string;
}

/** Debug fields the /generate endpoints echo back alongside imageUrl. */
export interface GenerateResultMeta {
  subject?: string | null;
  mood?: string | null;
  concept?: string | null;
  motifs?: string | null;
  prompt?: string;
  stylePresetId?: string;
  stylePresetLabel?: string;
  aspectRatio?: string;
  titleMode?: string;
  model?: string;
  provider?: string;
  error?: string;
}

export interface GenerateResponse extends GenerateResultMeta {
  imageUrl: string;
}
